import React from 'react';
import { Box, styled } from '@mui/material';

const BrowserFrame = styled(Box)(({ theme, direction = 'left' }) => ({
  position: 'relative',
  width: '400px',
  height: '300px',
  maxWidth: '100%',
  borderRadius: '12px',
  backgroundColor: '#f5f5f7',
  border: '1px solid #e0e0e0',
  boxShadow: '0 12px 40px rgba(0, 0, 0, 0.12)',
  transform: direction === 'left'
    ? 'perspective(800px) rotateY(25deg) rotateX(8deg)'
    : direction === 'right'
      ? 'perspective(800px) rotateY(-25deg) rotateX(8deg)'
      : 'perspective(800px) rotateY(0deg) rotateX(5deg)',
  transformOrigin: 'center center',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  overflow: 'hidden',
  '&:hover': {
    transform: 'perspective(800px) rotateY(0deg) rotateX(0deg) scale(1.08)',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.18)',
  },
  [theme.breakpoints.down('sm')]: {
    transform: direction === 'left'
      ? 'perspective(600px) rotateY(15deg) rotateX(5deg)'
      : direction === 'right'
        ? 'perspective(600px) rotateY(-15deg) rotateX(5deg)'
        : 'perspective(600px) rotateY(0deg) rotateX(3deg)',
    '&:hover': {
      transform: 'perspective(600px) rotateY(0deg) rotateX(0deg) scale(1.05)',
    },
  },
}));

const BrowserChrome = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '36px',
  backgroundColor: '#ffffff',
  borderBottom: '1px solid #e0e0e0',
  display: 'flex',
  alignItems: 'center',
  padding: '0 16px',
  gap: '8px',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: '#ff5f57',
    boxShadow: '20px 0 0 #ffbd2e, 40px 0 0 #28ca42',
  },
}));

const AddressBar = styled(Box)(({ theme }) => ({
  marginLeft: '68px',
  backgroundColor: '#f8f9fa',
  border: '1px solid #e9ecef',
  borderRadius: '20px',
  height: '24px',
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '12px',
  fontSize: '11px',
  color: '#6c757d',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
}));

const ScreenContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  height: 'calc(100% - 36px)',
  backgroundColor: '#ffffff',
  overflow: 'hidden',
});

const Screenshot = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'contain', // Changed from 'cover' to 'contain' to prevent cropping
  objectPosition: 'center',
  display: 'block',
  backgroundColor: '#f8f9fa', // Background color in case image doesn't fill completely
  borderRadius: '0 0 12px 12px',
});

const BrowserMockup3D = ({
  imageSrc,
  direction = 'left',
  alt = 'Screenshot',
  width = 400,
  height = 300
}) => {
  const handleImageError = (e) => {
    e.target.style.display = 'none';
  };

  return (
    <BrowserFrame direction={direction} sx={{ width: `${width}px`, height: `${height}px` }}>
      <BrowserChrome>
        <AddressBar>
          https://www.uben.online/
        </AddressBar>
      </BrowserChrome>
      <ScreenContainer>
        <Screenshot
          src={imageSrc}
          alt={alt}
          onError={handleImageError}
        />
      </ScreenContainer>
    </BrowserFrame>
  );
};

export default BrowserMockup3D;
